export const justifyColumnCenter = {
    justifyContent: 'center',
    flexDirection: 'column',
    display: 'flex',
}